module.exports = __webpack_public_path__ + "img/sibi_2kl.9ee58864.jpg";